/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import moment from 'moment-timezone';
import {
  Reservation,
  Product,
  Offer,
  ProductExtra,
  ReservationExtra,
} from 'rest-client';

import { BookingData } from '@app/modules/core/states/booking-state/booking.model';

import { DATE_TIME_FORMAT } from '../const/date-picker.consts';
import { COMMON_TERMINALS } from '../const/terminals.consts';
import { Terminal } from '../models';

export function setBookingFromReservation(
  reservation: Reservation
): BookingData {
  const product = new Product();
  product.name = reservation.product.productName;
  product.id = reservation.product.productId;

  const booking: BookingData = {
    startDate: moment(reservation.startDate, DATE_TIME_FORMAT).format(),
    endDate: moment(reservation.endDate, DATE_TIME_FORMAT).format(),
    product: product,
    place: null,
  };

  return booking;
}

export function setBookingFromOffer(
  offer: Offer,
  product: Product
): BookingData {
  product.name = product?.name;
  product.id = offer.productId;

  const booking: BookingData = {
    startDate: moment(offer.startDate, DATE_TIME_FORMAT).format(),
    endDate: moment(offer.endDate, DATE_TIME_FORMAT).format(),
    product: product,
    place: null,
  };

  return booking;
}

export function setOfferFromReservation(reservation: Reservation): Offer {
  const offer = new Offer();
  const extras: ProductExtra[] = [];

  reservation?.extras?.forEach((reservationExtra: ReservationExtra) => {
    extras.push(reservationExtra.extra);
  });
  offer.extras = extras;
  offer.mechanical_orders = reservation.mechanical_orders;
  offer.pvp_product_raw = reservation.pvp_product_raw;
  offer.pvp_product_option = reservation.pvp_product_option;
  offer.pvp_wash = reservation.pvp_wash;
  offer.pvp_product_points = reservation.pvp_product_points;
  offer.promos = reservation.promos;
  offer.pvp_product_promotion = reservation.pvp_product_promotion;
  offer.price = reservation.price;
  offer.pvp_mechanical_orders = reservation.pvp_mechanical_orders;
  offer.pvp_carservice_discount = reservation.pvp_carservice_discount;
  offer.endDate = reservation.endDate;
  offer.startDate = reservation.startDate;
  return offer;
}

export function getCommonTerminal(id: number): number {
  const terminals = COMMON_TERMINALS;
  return terminals.find(
    (terminal: Terminal) =>
      terminal.terminals.includes(id)
  )?.commonTerminalId;
}
